export enum ProcessBy {
  Vendor = 1,
  Employee = 2,
}

export enum ProcessByDescription {
  Vendor = 'Vendor',
  Employee = 'Employee',
}
